import boxheight from "./boxheight";
import Swal from "./sweetalert2";
import lazySizes from "lazysizes";

export function scrollToSmoothly(pos, time) {
    var currentPos = window.pageYOffset;
    var start = null;
    if (time == null) time = 500;
    (pos = +pos), (time = +time);
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(
                0,
                ((pos - currentPos) * progress) / time + currentPos
            );
        } else {
            window.scrollTo(
                0,
                currentPos - ((currentPos - pos) * progress) / time
            );
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    // sameheight
    let sameheight = document.querySelectorAll(".sameheight");
    boxheight(sameheight);

    // svg injectable
    //SVGInject(document.querySelector("img.injectable"));

    // native lazy loading or javascript with lazysizes
    const images = document.querySelectorAll("img[loading='lazy']")
    /* if ("loading" in HTMLImageElement.prototype) {
        // native lazy-loading supported
        for (const image of images) {
            console.log(image);
            console.log(image.dataset);
            if (image.dataset.src !== undefined) {
                console.log(image.dataset.src);
                image.src = image.dataset.src
            }
        }
    } else {
        // native lazy-loading not supported
        // dynamically load the lazysizes library
        window.lazySizesConfig = window.lazySizesConfig || {};
        lazySizesConfig.loadMode = 1;
        lazySizesConfig.preloadAfterLoad = true;
        lazySizesConfig.expand = 1500;
        lazySizesConfig.ricTimeout = 0;
        lazySizes.init();

        for (const image of images) {
            // request the low-quality image placeholder
            image.src = image.dataset.lqip
            // enable lazy-loading when user scrolls image into view or browser is idle
            image.classList.add("lazyload")
        }
    } */

    // fade in loading lazy
    let imagesLazy = document.querySelectorAll('.fadeInImg');
    imagesLazy.forEach(imageLazy => {
        imageLazy.addEventListener("load", (e) => {
            imageLazy.classList.add("loaded");
        });
        // metto animazione fade anche alle immagini caricate dalla cache (nessun evento load)
        setTimeout(() => {
            imageLazy.classList.add("loaded");
        }, 200);
    })

    // funzione che chiede la conferma all'utente prima di cliccare il button
    let cancellaAsk = document.querySelector(".cancellaAsk");
    if (cancellaAsk) {
        cancellaAsk.addEventListener("submit", (e, data) => {
            // invio form
            if (data) {
                if (data.invia) return;
            }
            e.preventDefault();

            Swal.fire({
                title: "Sei sicuro?",
                html: `Questo elemento verrà cancellato`,
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Si, cancella!",
                cancelButtonText: 'Annulla'
            }).then(result => {

                if (result.value == true) {
                    this.dispatchEvent(new Event("submit", [{ 'invia': true }]));
                }
            });
        });
    }

});

window.addEventListener('resize', event => {
    // sameheight
    let sameheight = document.querySelectorAll(".sameheight");
    boxheight(sameheight);
});
